// F3c-c1 stub — geo client seam. The GREEN engineer implements getTimezone to
// call GET /geo/timezone?lat&lng (the facility-identity panel resolves the IANA
// timezone from the verified facility coordinates). This stub exists only so the
// RED tests fail on missing BEHAVIOR (the panel never calls it), not on a missing
// module. Replace the body in GREEN.
import { httpClient } from "@bw/shared/api"

export interface TimezoneResult {
  timezone: string
  timezone_name?: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function getTimezone(_lat: number, _lng: number): Promise<TimezoneResult> {
  return httpClient.get<TimezoneResult>(`/geo/timezone?lat=${_lat}&lng=${_lng}`)
}
